export default "__VITE_ASSET__tatjwnw7__"